export const lang =
          [
  {
    "ID": "0",
    "field2": "位置",
    "zh-CN": "中文",
    "zh-TW": "繁体中文",
    "en": "英文",
    "ja": "日语",
    "ko": "韩语",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "1",
    "field2": "标题",
    "zh-CN": "兑换中心",
    "zh-TW": "虛寶碼兌換中心",
    "en": "Redeem Center",
    "ja": "交換センター",
    "ko": "교환 센터",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "2",
    "field2": "切换页面语言",
    "zh-CN": "语言",
    "zh-TW": "語言",
    "en": "Language",
    "ja": "言語",
    "ko": "언어",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "3",
    "field2": "相应语言-下拉框",
    "zh-CN": "",
    "zh-TW": "繁體中文",
    "en": "English",
    "ja": "日本語",
    "ko": "한국어",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "4",
    "field2": "输入框",
    "zh-CN": "用户ID",
    "zh-TW": "用戶ID",
    "en": "User ID",
    "ja": "ユーザーID",
    "ko": "유저ID",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "5",
    "field2": "输入框",
    "zh-CN": "兑换码",
    "zh-TW": "虛寶碼",
    "en": "Redemption Code",
    "ja": "引換コード",
    "ko": "쿠폰 번호",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "6",
    "field2": "输入框",
    "zh-CN": "验证码",
    "zh-TW": "驗證碼",
    "en": "Verification Code",
    "ja": "認証コード",
    "ko": "인증 번호",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "7",
    "field2": "按钮",
    "zh-CN": "兑换",
    "zh-TW": "兌換",
    "en": "Redeem",
    "ja": "交換",
    "ko": "교환",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "8",
    "field2": "兑换说明入口",
    "zh-CN": "查看兑换规则",
    "zh-TW": "查看兌換規則",
    "en": "Redemption Rules",
    "ja": "交換ルールを確認",
    "ko": "교환 규칙 확인",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "9",
    "field2": "兑换说明-标题",
    "zh-CN": "兑换说明",
    "zh-TW": "兌換說明",
    "en": "Redemption Instructions",
    "ja": "交換の説明",
    "ko": "교환 설명",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "10",
    "field2": "兑换说明-内容",
    "zh-CN": "同一个用户ID只能领取1次兑换码奖励。",
    "zh-TW": "同一個用戶ID只能領取一次虛寶碼獎勵。",
    "en": "Each User ID can only claim the redemption code reward once.",
    "ja": "同一ユーザーIDにつき、引換コードの報酬は1回のみ受け取れます。",
    "ko": "동일한 유저ID는 쿠폰 교환 번호 1회만 수령할 수 있습니다.",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "11",
    "field2": "兑换说明-内容",
    "zh-CN": "兑换完成后，奖励将通过游戏内邮件发送给您，请您重启游戏后查收。",
    "zh-TW": "兌換完成後，獎勵將通過遊戲內郵件發送給您，請您重啟遊戲後查收。",
    "en": "Once the redemption is completed, the reward will be sent to you via in-game mail. Please restart the game to check for it.",
    "ja": "交換完了後、報酬はゲーム内のメールで送信されます。ゲームを再起動して確認してください。",
    "ko": "교환 완료 후 보상은 게임 내 우편함으로 지급되니 게임을 재시작한 후 확인해 주세요.",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "12",
    "field2": "兑换说明-内容",
    "zh-CN": "若您遇到问题，请联系我们的支持团队：gongjian2@habby.com",
    "zh-TW": "若您遇到問題，請聯繫我們的支持團隊：",
    "en": "If you encounter any issues, please contact our support team:",
    "ja": "問題が発生した場合は、サポートチームにお問い合わせください：",
    "ko": "문제가 발생하실 경우, 지원팀에 문의해 주세요:",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "13",
    "field2": "找用戶ID入口",
    "zh-CN": "如何找到用户ID？",
    "zh-TW": "如何找到用戶ID？",
    "en": "Where is my User ID?",
    "ja": "ユーザーIDの確認方法",
    "ko": "유저ID 확인 방법",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "14",
    "field2": "找用户ID标题",
    "zh-CN": "如何找到用户ID？",
    "zh-TW": "如何找到用戶ID？",
    "en": "Where is my User ID?",
    "ja": "ユーザーIDの確認方法",
    "ko": "유저ID 확인 방법",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "15",
    "field2": "下载按钮",
    "zh-CN": "前往下载",
    "zh-TW": "前往下載",
    "en": "Download",
    "ja": "ダウンロードへ",
    "ko": "다운로드하기",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "16",
    "field2": "输入框",
    "zh-CN": "点击图片刷新验证码",
    "zh-TW": "點擊圖片刷新驗證碼",
    "en": "To refresh the code, tap the image",
    "ja": "コードを更新するには、画像をタップしてください",
    "ko": "확인 코드를 새로 고침하려면 이미지를 탭하세요",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "17",
    "field2": "Step 1",
    "zh-CN": "1. 进入游戏，点击首页的“设置”按钮。",
    "zh-TW": "1.  進入遊戲，點擊首頁的“設定”按鈕。",
    "en": "1. Enter the game and tap the \"Settings\".",
    "ja": "1.ゲームを起動し、ホーム画面の「設定」ボタンをタップします。",
    "ko": "1. 게임에 접속한 후, 홈 화면에서 '설정' 버튼을 탭하세요.",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "18",
    "field2": "Step 2",
    "zh-CN": "2. 数字即为您的游戏ID。",
    "zh-TW": "2.數字即為您的遊戲ID。",
    "en": "2. This number is your User ID.",
    "ja": "2.表示される数字があなたのユーザーIDです。",
    "ko": "2. 해당 번호가 바로 유저님의 ID입니다.",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "19",
    "field2": "弹窗按钮",
    "zh-CN": "是",
    "zh-TW": "是",
    "en": "Yes!",
    "ja": "はい！",
    "ko": "네",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "20",
    "field2": "弹窗按钮",
    "zh-CN": "否",
    "zh-TW": "否",
    "en": "No, wait.",
    "ja": "いいえ",
    "ko": "아니오",
    "field8": "",
    "field9": ""
  },
  {
    "ID": "21",
    "field2": "弹窗",
    "zh-CN": "恭喜您兑换成功！奖励已发送到您游戏中的邮箱，请及时查收！",
    "zh-TW": "恭喜您兌換成功！獎勵已發送到您遊戲中的郵箱，請及時查收！",
    "en": "Congratulations! Your rewards have been sent to your in-game Mailbox. Go and check it out!",
    "ja": "おめでとうございます！報酬がゲーム内のメールボックスに送信されました。早速チェックしよう！",
    "ko": "축하합니다! 보상은 게임 내 우편함으로 발송되었으니 확인하세요!",
    "field8": "0",
    "field9": ""
  },
  {
    "ID": "22",
    "field2": "",
    "zh-CN": "兑换失败！参数错误。",
    "zh-TW": "兌換失敗！參數錯誤。",
    "en": "Redeem failed; information incorrect",
    "ja": "交換に失敗しました：情報が誤っています",
    "ko": "교환 실패! 잘못된 정보",
    "field8": "20001",
    "field9": ""
  },
  {
    "ID": "23",
    "field2": "",
    "zh-CN": "兑换失败！验证码有误。",
    "zh-TW": "兌換失敗！驗證碼有誤。",
    "en": "Redeem failed; incorrect Verification Code",
    "ja": "交換に失敗しました：確認コードが誤っています",
    "ko": "교환 실패! 잘못된 확인 코드",
    "field8": "20002",
    "field9": ""
  },
  {
    "ID": "24",
    "field2": "弹窗",
    "zh-CN": "兑换失败！您的ID错误，请确认",
    "zh-TW": "兌換失敗！您的ID錯誤，請確認",
    "en": "Oh no, we suspect your ID is incorrect. Please check again.",
    "ja": "IDが誤っているようです。もう一度ご確認ください。",
    "ko": "교환 실패! ID가 틀린 것 같습니다. 다시 확인해주세요.",
    "field8": "20003",
    "field9": ""
  },
  {
    "ID": "25",
    "field2": "弹窗",
    "zh-CN": "兑换失败！您的兑换码错误，请确认",
    "zh-TW": "兌換失敗！您的兌換碼錯誤，請確認",
    "en": "Oh no, we suspect your Rewards Code is incorrect. Please check again.",
    "ja": "報酬コードが誤っているようです。もう一度ご確認ください。",
    "ko": "교환 실패! 기프트코드가 틀린 것 같습니다. 다시 확인해주세요.",
    "field8": "20401",
    "field9": ""
  },
  {
    "ID": "26",
    "field2": "弹窗",
    "zh-CN": "兑换失败！您的兑换码已使用，无法再次兑换奖励",
    "zh-TW": "兌換失敗！您的兌換碼已使用，無法再次兌換獎勵",
    "en": "Oh no, your Rewards Code has already been used!",
    "ja": "報酬コードがすでに使用されています！",
    "ko": "교환 실패! 기프트코드를 이미 사용했습니다. 재사용할 수 없습니다.",
    "field8": "20402",
    "field9": ""
  },
  {
    "ID": "27",
    "field2": "弹窗",
    "zh-CN": "兑换失败！您的兑换码已过期，无法兑换奖励",
    "zh-TW": "兌換失敗！您的兌換碼已過期，無法兌換獎勵",
    "en": "Oh no, your Rewards Code has expired...",
    "ja": "報酬コードが期限切れです…",
    "ko": "교환 실패! 기프트코드가 만료되었습니다.",
    "field8": "20403",
    "field9": ""
  },
  {
    "ID": "28",
    "field2": "",
    "zh-CN": "礼包码未生效",
    "zh-TW": "兌換碼未生效，請稍後嘗試",
    "en": "Redeem code is not activated, please try it later.",
    "ja": "利用コードが有効化されていません。しばらくしてからお試しください。",
    "ko": "코드 사용이 활성화되지 않았습니다. 나중에 시도하십시오.",
    "field8": "20404",
    "field9": ""
  },
  {
    "ID": "29",
    "field2": "",
    "zh-CN": "同一类型兑换码仅可使用1次，重复领取无法使用",
    "zh-TW": "同一類型兌換碼僅可使用1次",
    "en": "Codes of similar items can only be claimed once",
    "ja": "同じタイプのギフトコードは 1 回のみ使用でき。",
    "ko": "동일유형 기프트코드는 1회만.",
    "field8": "20407",
    "field9": ""
  },
  {
    "ID": "30",
    "field2": "",
    "zh-CN": "此兑换码已兑换完毕，无法再兑换。",
    "zh-TW": "此兌換碼已兌換完畢，無法再兌換。",
    "en": "This redemption code has already been redeemed and can no longer be redeemed.",
    "ja": "この引き換えコードはすでに引き換えられており、引き換えることはできません。",
    "ko": "이 사용 코드는 이미 사용되었으며 더 이상 사용할 수 없습니다.",
    "field8": "20409",
    "field9": ""
  },
  {
    "ID": "31",
    "field2": "",
    "zh-CN": "抱歉，您被暂时禁止兑换此礼品码。",
    "zh-TW": "抱歉，您被暫時禁止兌換此禮品碼。",
    "en": "You are temporarily unable to redeem this gift code.",
    "ja": "誠に申し訳ございませんが、このギフトコードは一時的にご利用いただけません",
    "ko": "일시적으로 기프트 코드 교환이 불가능합니다.",
    "field8": "20410",
    "field9": ""
  },
  {
    "ID": "32",
    "field2": "",
    "zh-CN": "服务器繁忙，请重试。",
    "zh-TW": "服務器繁忙，請重試。",
    "en": "Server is busy, please try again.",
    "ja": "サーバーがビジー状態です。もう一度お試しください。",
    "ko": "서버 오류, 다시 시도해주세요.",
    "field8": "30001",
    "field9": ""
  },
  {
    "ID": "33",
    "field2": "",
    "zh-CN": "您确认为此ID兑换奖励吗？",
    "zh-TW": "您確認為此ID兌換獎勵嗎？",
    "en": "Confirm redeeming the code for this ID?",
    "ja": "このIDに対してコードの交換を確定しますか？",
    "ko": "이 ID를 사용하여 코드를 교환하시겠습니까?",
    "field8": "",
    "field9": ""
  }
]
        


// WEBPACK FOOTER //
// ./src/tool/lang.js